import { useEffect, useState } from "react";

import { InputText } from "primereact/inputtext";
import { Dropdown } from 'primereact/dropdown';

import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from "primereact/inputnumber";
import useApi from "../../../hooks/ApiHook";
        

const GeneralInformation = ({
  generalData,
  setGeneralData
}) => {
  const api = useApi();
  const [selectedState, setSelectedState] = useState({ name: 'Acre', code: 'AC' });
  const [priceTableList, setPriceTableList] = useState();

  useEffect(() => {
    api.get('price-tables', { params: { limit: 100 } }).then(result => {
      setPriceTableList(result.data.data)
    });
  }, []);

  const states = [
    { name: 'Acre', code: 'AC' },
    { name: 'Alagoas', code: 'AL' },
    { name: 'Amapá', code: 'AP' },
    { name: 'Amazonas', code: 'AM' },
    { name: 'Bahia', code: 'BA' },
    { name: 'Ceará', code: 'CE' },
    { name: 'Distrito Federal', code: 'DF' },
    { name: 'Espírito Santo', code: 'ES' },
    { name: 'Goiás', code: 'GO' },
    { name: 'Maranhão', code: 'MA' },
    { name: 'Mato Grosso', code: 'MT' },
    { name: 'Mato Grosso do Sul', code: 'MS' },
    { name: 'Minas Gerais', code: 'MG' },
    { name: 'Pará', code: 'PA' },
    { name: 'Paraíba', code: 'PB' },
    { name: 'Paraná', code: 'PR' },
    { name: 'Pernambuco', code: 'PE' },
    { name: 'Piauí', code: 'PI' },
    { name: 'Rio de Janeiro', code: 'RJ' },
    { name: 'Rio Grande do Norte', code: 'RN' },
    { name: 'Rio Grande do Sul', code: 'RS' },
    { name: 'Rondônia', code: 'RO' },
    { name: 'Roraima', code: 'RR' },
    { name: 'Santa Catarina', code: 'SC' },
    { name: 'São Paulo', code: 'SP' },
    { name: 'Sergipe', code: 'SE' },
    { name: 'Tocantins', code: 'TO' }
  ];

  return (
    <div className="grid gap-y-4">
      <div className="field col-3">
        <label 
          htmlFor="destinyCompany" 
          className="text-gray-500 text-base"
        >
          Empresa de destino
        </label>

        <InputText
          id="destinyCompany"
          value={generalData?.destinyCompany}
          readOnly
          onChange={e => setGeneralData({
            ...generalData,
            destinyCompany: e.target.value
          })}
          className="w-full"
        />
      </div>

      <div className="field col-3">
        <label 
          htmlFor="destinyState" 
          className="text-gray-500 text-base"
        >
          Estado de destino
        </label>

          <Dropdown
            id="destinyState"
            value={selectedState}
            readOnly
            // onChange={(e) => {
            //   setGeneralData({
            //     ...generalData,
            //     destinyState: e.value.code
            //   })

            //   setSelectedState(e.value);
            // }} 
            options={states} 
            optionLabel="code" 
            placeholder="Selecione o estado" 
            className="w-full" 
          />
      </div>

      <div className="field col-3">
        <label 
          htmlFor="cfop" 
          className="text-gray-500 text-base"
        >
          CFOP
        </label>
        
        <InputNumber
            id="cfop"
            value={generalData?.cfop}
            useGrouping={false}
            onChange={e => setGeneralData({
              ...generalData,
              cfop: e.value
            })}
            className="w-full"
          />
      </div>

      <div className="field col-3">
        <label 
          htmlFor="priceTable" 
          className="text-gray-500 text-base"
        >
          Tabela de preços
        </label>

          <Dropdown
            id="priceTable"
            value={generalData.priceTable}
            onChange={(e) => {
              setGeneralData({
                ...generalData,
                priceTable: e.value
              })
            }} 
            options={priceTableList} 
            loading={!priceTableList}
            optionLabel="description" 
            placeholder={'Selecione uma tabela de preços'}
            showClear
            className="w-full" 
          />
      </div>

      <div className="field col-12">
        <label 
          htmlFor="additionalMessage" 
          className="text-gray-500 text-base"
        >
          Mensagem adicional
        </label>

        <InputTextarea 
          id="additionalMessage"
          value={generalData?.additionalMessage} 
          onChange={(e) => setGeneralData({
            ...generalData,
            additionalMessage: e.target.value
          })} 
          className="w-full" 
        />
      </div>
    </div>
  );
}

export default GeneralInformation;